export default __webpack_public_path__ + "mfa-logo.cef8226eab41342fa5719cf58c73d576.svg";